import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * AuthCallback - Handles Google OAuth callback from Emergent Auth
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get("session_id");

        if (!sessionId) {
          console.error("No session_id found in URL");
          navigate("/login", { replace: true });
          return;
        }

        // Exchange session_id for our session token
        const response = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId
        });

        if (response.data.success) {
          const { session_token, user } = response.data;
          
          // Store session data
          localStorage.setItem("customer_token", session_token);
          localStorage.setItem("customer_id", user.customer_id);
          localStorage.setItem("customer_name", user.name);
          localStorage.setItem("customer_email", user.email);
          localStorage.setItem("customer_picture", user.picture || "");
          localStorage.setItem("customer_balance", user.balance || 0);
          localStorage.setItem("customer_role", "pelanggan");

          // Clear URL hash and redirect to customer dashboard
          window.history.replaceState(null, "", window.location.pathname);
          navigate("/pelanggan", { replace: true, state: { user } });
        } else {
          console.error("Auth failed:", response.data);
          navigate("/login", { replace: true });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen hero-gradient flex items-center justify-center">
      <div className="text-center">
        <div className="spinner w-12 h-12 mx-auto mb-4 border-4 border-sky-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-slate-600">Memproses login...</p>
      </div>
    </div>
  );
}
